import { createStore, applyMiddleware, compose } from "redux"
import logger from 'redux-logger'
import thunk from 'redux-thunk'
import rootReducer from "./reducers"


// const sagaMiddleware = createSagaMiddleware()
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const Mode = "dev";
let store;
if (Mode === 'dev') {
  store = createStore(
    rootReducer,
    composeEnhancers(
      applyMiddleware(logger, thunk)
    )
  )
} else {
  store = createStore(
    rootReducer,
    applyMiddleware(thunk)
  )
}

// sagaMiddleware.run(rootSaga)

export default store
